/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_Dvc_Search_Type_UnavailableInputs */

const en_api_error_dvc_search_type_unavailable = /** @type {(inputs: Api_Error_Dvc_Search_Type_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A current-owner lookup is not available for incidents older than 6 months.`)
};

const pt_br2_api_error_dvc_search_type_unavailable = /** @type {(inputs: Api_Error_Dvc_Search_Type_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consulta de proprietário atual indisponível para acidentes com mais de 6 meses.`)
};

/**
* | output |
* | --- |
* | "A current-owner lookup is not available for incidents older than 6 months." |
*
* @param {Api_Error_Dvc_Search_Type_UnavailableInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const api_error_dvc_search_type_unavailable = /** @type {((inputs?: Api_Error_Dvc_Search_Type_UnavailableInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_Dvc_Search_Type_UnavailableInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_dvc_search_type_unavailable(inputs)
	return pt_br2_api_error_dvc_search_type_unavailable(inputs)
});